import { ReactNode, useState } from 'react';

import { LinkButton } from '@client:common/button';
import { GlobalStore } from '@client:common/global-store';
import { Theme } from '@client:common/Theme';

import { ThemeToggle } from './views/theme-toggle/ThemeToggle';

import './Banner.light.scss';
import './Banner.dark.scss';

interface Props {
  children?: ReactNode | ReactNode[];
  setLoadSession: (loadSession: any) => void;
}

export function Banner(props: Props) {
  const [currentTheme, setCurrentTheme] = useState<Theme>(Theme.DARK);
  const onThemeChange = (newTheme: Theme) => {
    const globalStore = GlobalStore.getInstance();

    setCurrentTheme(newTheme);
    globalStore.update({
      currentTheme: newTheme
    });
  };

  return (
    <div className='banner'>
      <header className='banner__header'>
        <LinkButton to='/'>
          <img
            className='banner__site-logo'
            src={`/images/${currentTheme}-mode-site-logo.svg`}
            onClick={() => props.setLoadSession(null)}
          />
        </LinkButton>
      </header>
      <ThemeToggle onThemeChange={onThemeChange} />
      {props.children}
    </div>
  );
}
